/**
 * Global PDP hero product gallery — stacked slides, thumbs, prev/next, optional variant ↔ image sync.
 * Used by Universal PDP, PCOS universal PDP, and Modular PDP via snippets/pdp-hero-gallery.liquid.
 */

(function() {
  'use strict';

  // --- Lightbox ---
  var lightbox = (function() {
    var el, imgEl, slides, index;

    function show(idx) {
      index = (idx + slides.length) % slides.length;
      var slide = slides[index];
      imgEl.src = slide.getAttribute('data-zoom-src') || slide.querySelector('img').src;
      imgEl.alt = slide.getAttribute('data-zoom-alt') || slide.querySelector('img').alt || '';
      var hasMultiple = slides.length > 1;
      el.querySelector('.pdp-lightbox__nav--prev').hidden = !hasMultiple;
      el.querySelector('.pdp-lightbox__nav--next').hidden = !hasMultiple;
    }

    function close() {
      el.classList.remove('is-open');
      document.body.style.overflow = '';
      imgEl.src = '';
    }

    function open(slideEls, startIndex) {
      if (!el) build();
      slides = slideEls;
      show(startIndex);
      el.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function build() {
      el = document.createElement('div');
      el.className = 'pdp-lightbox';
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.setAttribute('aria-label', 'Product image');
      el.innerHTML = [
        '<div class="pdp-lightbox__backdrop"></div>',
        '<button class="pdp-lightbox__close" aria-label="Close">',
          '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>',
        '</button>',
        '<button class="pdp-lightbox__nav pdp-lightbox__nav--prev" aria-label="Previous image">',
          '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/></svg>',
        '</button>',
        '<img class="pdp-lightbox__img" src="" alt="">',
        '<button class="pdp-lightbox__nav pdp-lightbox__nav--next" aria-label="Next image">',
          '<svg fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/></svg>',
        '</button>'
      ].join('');
      document.body.appendChild(el);

      imgEl = el.querySelector('.pdp-lightbox__img');
      el.querySelector('.pdp-lightbox__backdrop').addEventListener('click', close);
      el.querySelector('.pdp-lightbox__close').addEventListener('click', close);
      el.querySelector('.pdp-lightbox__nav--prev').addEventListener('click', function() { show(index - 1); });
      el.querySelector('.pdp-lightbox__nav--next').addEventListener('click', function() { show(index + 1); });

      document.addEventListener('keydown', function(e) {
        if (!el.classList.contains('is-open')) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') show(index - 1);
        if (e.key === 'ArrowRight') show(index + 1);
      });
    }

    return { open: open };
  })();

  function getPdpVariantsData() {
    var el = document.getElementById('pdp-all-variants-data');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function initGalleryRoot(root) {
    if (!root || root.getAttribute('data-pdp-hero-gallery-initialized') === 'true') return;
    root.setAttribute('data-pdp-hero-gallery-initialized', 'true');

    var syncMode = root.getAttribute('data-variant-sync') || 'off';
    var mobilePeek = root.classList.contains('pdp-hero-gallery--mobile-peek');
    var mqTablet = window.matchMedia('(min-width: 768px)');
    var slideEls = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-hero-gallery-slide]'));
    var thumbEls = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-hero-gallery-thumb]'));
    var prevBtn = root.querySelector('[data-pdp-hero-gallery-prev]');
    var nextBtn = root.querySelector('[data-pdp-hero-gallery-next]');
    var mainWrap = root.querySelector('.pdp-hero-gallery__main-wrap');

    if (slideEls.length === 0) return;

    var activeIndex = 0;
    var peekPointerX = null;

    function isPeekMode() {
      return mobilePeek && !mqTablet.matches && slideEls.length > 1;
    }

    function scrollActiveThumbInStrip(thumb, smooth) {
      var strip = thumb.closest('.pdp-hero-gallery__thumbs');
      if (!strip) return;
      var left = thumb.offsetLeft;
      var w = thumb.offsetWidth;
      var target = left - strip.clientWidth / 2 + w / 2;
      strip.scrollTo({ left: Math.max(0, target), behavior: smooth ? 'smooth' : 'auto' });
    }

    function setActiveIndex(index, options) {
      options = options || {};
      activeIndex = (index + slideEls.length) % slideEls.length;

      slideEls.forEach(function(slide, i) {
        slide.classList.toggle('is-active', i === activeIndex);
      });

      var scrollThumbs = options.scrollThumbs !== false && !isPeekMode();
      thumbEls.forEach(function(thumb, i) {
        var isActive = i === activeIndex;
        thumb.classList.toggle('is-active', isActive);
        if (isActive && scrollThumbs) {
          scrollActiveThumbInStrip(thumb, options.smooth !== false);
        }
      });

      if (options.scrollToSlide !== false && isPeekMode() && mainWrap) {
        var targetSlide = slideEls[activeIndex];
        if (targetSlide) {
          mainWrap.scrollTo({
            left: targetSlide.offsetLeft,
            behavior: options.smooth === false ? 'auto' : 'smooth'
          });
        }
      }
    }

    function getFeaturedImageIdUniversal() {
      var activeOpt = document.querySelector('.pdp-details__selection-option--active');
      if (!activeOpt) return null;

      var variantId = activeOpt.getAttribute('data-variant-id');
      var qty = activeOpt.getAttribute('data-quantity');
      if (qty && window.findVariantByQuantityAndFlavor && window.getSelectedFlavor) {
        var resolved = window.findVariantByQuantityAndFlavor(qty, window.getSelectedFlavor());
        if (resolved) variantId = String(resolved);
      }

      var data = getPdpVariantsData();
      if (variantId && data && data.variants) {
      var row = null;
      for (var i = 0; i < data.variants.length; i++) {
        if (String(data.variants[i].id) === String(variantId)) {
          row = data.variants[i];
          break;
        }
      }
        if (row && row.featured_image_id != null && row.featured_image_id !== '') {
          return String(row.featured_image_id);
        }
      }

      return activeOpt.getAttribute('data-variant-featured-image-id');
    }

    function getFeaturedImageIdPcos(rootEl) {
      var hero = rootEl.closest('[data-pcos-hero]');
      if (!hero) return null;

      var active = hero.querySelector('[data-variant-option].is-active');
      if (active) {
        return active.getAttribute('data-variant-featured-image-id');
      }

      var form = hero.querySelector('[data-nnh-form]');
      var variantInput = form && form.querySelector('[data-nnh-variant-id]');
      var variantId = variantInput && variantInput.value;
      if (!variantId) return null;

      var data = getPdpVariantsData();
      if (data && data.variants) {
        for (var i = 0; i < data.variants.length; i++) {
          if (String(data.variants[i].id) === String(variantId)) {
            var fid = data.variants[i].featured_image_id;
            if (fid != null && fid !== '') return String(fid);
            break;
          }
        }
      }

      return null;
    }

    function syncFromVariant() {
      var fid = null;
      if (syncMode === 'universal') {
        fid = getFeaturedImageIdUniversal();
      } else if (syncMode === 'pcos-hero') {
        fid = getFeaturedImageIdPcos(root);
      }
      if (!fid) return;
      var idx = -1;
      for (var j = 0; j < slideEls.length; j++) {
        if (String(slideEls[j].getAttribute('data-image-id')) === String(fid)) {
          idx = j;
          break;
        }
      }
      if (idx >= 0) setActiveIndex(idx);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        setActiveIndex(activeIndex - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        setActiveIndex(activeIndex + 1);
      });
    }
    thumbEls.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        setActiveIndex(Number(thumb.getAttribute('data-thumb-index') || 0));
      });
    });

    if (mobilePeek && mainWrap && slideEls.length > 1) {
      var peekObserver = new IntersectionObserver(
        function(entries) {
          if (!isPeekMode()) return;
          var best = null;
          entries.forEach(function(entry) {
            if (!entry.isIntersecting) return;
            if (!best || entry.intersectionRatio > best.intersectionRatio) {
              best = entry;
            }
          });
          if (!best) return;
          var idx = slideEls.indexOf(best.target);
          if (idx >= 0 && idx !== activeIndex) {
            setActiveIndex(idx, { scrollToSlide: false, scrollThumbs: false });
          }
        },
        { root: mainWrap, threshold: 0.6 }
      );
      slideEls.forEach(function(slide) {
        peekObserver.observe(slide);
      });

      mqTablet.addEventListener('change', function() {
        setActiveIndex(activeIndex, { smooth: false, scrollThumbs: false });
      });
    }

    if (mainWrap) {
      mainWrap.addEventListener('pointerdown', function(e) {
        if (isPeekMode()) peekPointerX = e.clientX;
      }, { passive: true });

      mainWrap.addEventListener('click', function(e) {
        if (e.target.closest('.pdp-hero-gallery__nav')) return;
        if (isPeekMode() && peekPointerX !== null && Math.abs(e.clientX - peekPointerX) > 10) return;
        lightbox.open(slideEls, activeIndex);
      });
    }

    if (syncMode === 'universal') {
      document.addEventListener('click', function(e) {
        if (!e.target.closest || !e.target.closest('.pdp-details__selection-option')) return;
        window.requestAnimationFrame(syncFromVariant);
      });
      document.addEventListener('flavorChanged', function() {
        window.requestAnimationFrame(syncFromVariant);
      });
      window.addEventListener('popstate', function() {
        window.requestAnimationFrame(syncFromVariant);
      });
    }

    if (syncMode === 'pcos-hero') {
      document.addEventListener('click', function(e) {
        var btn = e.target.closest && e.target.closest('[data-variant-option]');
        if (!btn || !btn.closest('[data-pcos-hero]')) return;
        window.requestAnimationFrame(syncFromVariant);
      });
      window.addEventListener('popstate', function() {
        window.requestAnimationFrame(syncFromVariant);
      });
      document.addEventListener('flavorChanged', function() {
        window.requestAnimationFrame(syncFromVariant);
      });
      document.addEventListener('pdp-hero-gallery:sync-context', function() {
        window.requestAnimationFrame(syncFromVariant);
      });
    }

    setActiveIndex(0, { scrollThumbs: false, smooth: false });

    if (syncMode === 'universal') {
      window.requestAnimationFrame(syncFromVariant);
      setTimeout(syncFromVariant, 250);
    }
    if (syncMode === 'pcos-hero') {
      window.requestAnimationFrame(syncFromVariant);
      setTimeout(syncFromVariant, 50);
      setTimeout(syncFromVariant, 250);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-pdp-hero-gallery]').forEach(initGalleryRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
